import { mode, StyleFunctionProps, SystemStyleObject } from '@chakra-ui/theme-tools';

function baseStyleControl(props: StyleFunctionProps) {
  const { colorScheme: c } = props;
  return {
    borderColor: mode(`gray.200`, `gray.600`)(props),
    _checked: {
      bg: mode(`${c}.700`, `${c}.200`)(props),
      borderColor: mode(`${c}.700`, `${c}.200`)(props),

      _hover: {
        bg: mode(`${c}.800`, `${c}.300`)(props),
        borderColor: mode(`${c}.800`, `${c}.300`)(props),
      },
    },
    _focus: {
      boxShadow: 'none',
    },
  };
}

const baseStyle = (props: StyleFunctionProps) => ({
  control: baseStyleControl(props),
});

const sizes = {
  xs: {
    control: { h: 3, w: 3 },
    label: { fontSize: 'sm' },
    icon: { fontSize: '0.45rem' },
  },
  sm: {
    control: { h: 4, w: 4 },
    label: { fontSize: 'sm' },
    icon: { fontSize: '0.625rem' },
  },
  md: {
    control: { w: 5, h: 5 },
    label: { fontSize: 'md' },
    icon: { fontSize: '0.625rem' },
  },
  lg: {
    control: { w: 6, h: 6 },
    label: { fontSize: 'md' },
    icon: { fontSize: '0.75rem' },
  },
  xl: {
    control: { w: 8, h: 8 },
    label: { fontSize: 'lg' },
    icon: { fontSize: '1rem' },
  },
};

const defaultProps = {
  colorScheme: 'green',
};

const variants = {
  simple: ({ colorMode }: StyleFunctionProps): SystemStyleObject => ({
    control: {
      rounded: 'base',
      borderColor: 'gray.600',
      color: 'gray.600',
      _hover: {
        color: 'gray.800',
      },
      _checked: {
        bg: 'green.800',
        borderColor: 'green.800',
        color: 'white',
        _hover: {
          bg: 'green.900',
          borderColor: 'green.900',
          color: 'white',
        },
        _disabled: {
          color: 'white',
        },
      },
      _disabled: {
        bgColor: 'inherit',
        borderColor: colorMode === 'dark' ? 'gray.800' : 'gray.300',
      },
    },
    label: {
      ml: 3,
    },
  }),
};

export default {
  baseStyle,
  sizes,
  defaultProps,
  variants,
};
